<template>
  <div style="flex-grow: 1">
    <iframe
      ref="myIframe"
      same-site="none"
      :src="jumpUrl"
      :style="{ border: 'none',marginLeft: '10px' }"
      width="99%"
      height="99%"
    />
  </div>
</template>

<script>

import * as InsuranceConstants from '@/class/cargo/model/parameters/InsuranceConstants'

export default {
  name: 'InsureIframe',
  components: {},
  props: {
    jumpUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      insuranceAgents: InsuranceConstants.INSURANCE_AGENT,
      insuranceAgent: ''
    }
  },
  created() {
  },
  methods: {
    changeAgent(data) {
      this.insuranceAgent = data
    }
  }
}
</script>

<style lang="scss" scoped>
</style>>
